import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommunicationService {
  // Used to trigger a toggle event
  private expandCollapseEvent = new Subject<void>();
  expandCollapseEvent$ = this.expandCollapseEvent.asObservable();

  private subTabEvent = new Subject<boolean>();
  subTabEvent$ = this.subTabEvent.asObservable();

  // Keeps track of expand/collapse state
  private expandCollapseState = new BehaviorSubject<boolean>(false);
  expandCollapseState$ = this.expandCollapseState.asObservable();

  triggerToggle() {
    this.expandCollapseEvent.next(); // Notify toggle
  }

  switchSubTabs(state:boolean){
    this.subTabEvent.next(state)
  }

  updateState(state: boolean) {
    this.expandCollapseState.next(state); // Push new state
  }
}
